import React from "react";
import Dimensions from "../Dimensions/index.mjs";
function useWindowDimensions() {
  const [dims, setDims] = React.useState(() => Dimensions.get("window"));
  return React.useEffect(() => {
    function handleChange({
      window
    }) {
      window != null && setDims(window);
    }
    return Dimensions.addEventListener("change", handleChange), setDims(Dimensions.get("window")), () => {
      Dimensions.removeEventListener("change", handleChange);
    };
  }, []), dims;
}
export { useWindowDimensions as default };
//# sourceMappingURL=index.mjs.map
